import {
  osVersion,
  osName,
  browserName,
  browserVersion,
} from 'react-device-detect';

import { version } from '../../../package.json';

import * as StorageService from '@portal/services/storage';
import ErrorsMessages from '@portal/enum/errors';
import { DeviceType } from '@portal/models/enumerators';

export const getMetadata = async (): Promise<models.MetaData> => {
  const deviceId = StorageService.getDeviceId();

  if (!deviceId) {
    throw new Error(ErrorsMessages.DEVICE_ID_NOT_SET);
  }

  const metadata: models.MetaData = {
    deviceInfo: {
      appVersion: version,
      carrier: null,
      deviceId,
      deviceOSVersion: osVersion,
      deviceType: DeviceType.WEB,
      macAddress: null,
      manufacturer: null,
      model: `${browserName} ${browserVersion}`,
      platform: osName,
    },
  };

  return metadata;
};
